// #Fase2-C2 — La API sigue siendo la autoridad; la UI oculta acciones ajenas.
export function ownsTemplate(user, template) {
  return user?.role === 'super_admin' ||
    (user?.role === 'lider_proyecto' && !!user.id && template?.owner_id === user.id);
}

export function questionLocked(user, question) {
  return user?.role !== 'super_admin' && !!question?.locked;
}
